import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import WriteTextForm from '../forms/write-text-form';
import { textWriteValidationSchema } from '../schema/text.js';

export default function WriteTextNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Write Text Node Details',
        altText: 'Write Text Node',
        defaultLabel: 'Write Text Node',
      }}
    >
      <CommonNode FormComponent={WriteTextForm} schemaResolver={textWriteValidationSchema} />
    </NodeProvider>
  );
}
